import { useNavigate, useRouteError } from 'react-router'

import { ErrorFallback } from './error-fallback'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  return <ErrorFallback error={error} onReset={() => navigate(0)} />
}
